







































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    spot: {
      type: Object,
      required: true
    }
  }
})
export default class Sight extends Vue {
  private steps (start: number, end: number, step: number) {
    const generator = function* () {
      for (let i = start; i < end; i += step) {
        yield i;
      }
    };
    return [...generator()];
  }
}
